/** Каталог якорей модуля «Заявки» */
export const TICKETS_ANCHORS = {
  /** Шестерёнка настроек модуля у пункта «Заявки» в боковом меню */
  nav: {
    settings: 'tickets.nav.settings',
  },
  table: {
    create: 'tickets.table.create',
    statistics: 'tickets.table.statistics',
    reports: 'tickets.table.reports',
    settings: 'tickets.table.settings',
    settingsCategories: 'tickets.table.settings.categories',
    settingsWorkGroups: 'tickets.table.settings.workGroups',
    export: 'tickets.table.export',
    search: 'tickets.table.search',
    requiresAction: 'tickets.table.requiresAction',
    resetFilters: 'tickets.table.resetFilters',
    hideCompleted: 'tickets.table.hideCompleted',
    /** Префикс якоря заголовка колонки с фильтром, дальше — ключ колонки из `headers` */
    filterPrefix: 'tickets.table.filter.',
    filterFirst: 'tickets.table.filter.number',
    filterLast: 'tickets.table.filter.status',
    demoRow: 'tickets.table.demoRow',
  },
  categories: {
    filter: 'tickets.categories.filter',
    view: 'tickets.categories.view',
    viewLast: 'tickets.categories.viewLast',
    create: 'tickets.categories.create',
    tree: 'tickets.categories.tree',
  },
  workGroups: {
    add: 'tickets.workGroups.add',
    table: 'tickets.workGroups.table',
  },
  form: {
    serviceCategory: 'tickets.form.serviceCategory',
    department: 'tickets.form.department',
    location: 'tickets.form.location',
    files: 'tickets.form.files',
    assignSelf: 'tickets.form.assignSelf',
    save: 'tickets.form.save',
    historyTab: 'tickets.form.historyTab',
    assignCoordinator: 'tickets.form.assignCoordinator',
  },
} as const

/** Имена контекстов модуля */
export const TICKETS_CONTEXTS = {
  table: 'tickets.table',
  workGroups: 'tickets.workGroups',
  form: 'tickets.form',
  formTasks: 'tickets.form.tasks',
} as const
